import { useEffect, useState, useContext } from "react";
import axios from "axios";
import ContextData from '../store/context-data';
import { Container, Grid, Header, Icon, Image, Card, Form, Input, Button, Modal, Table, Radio, Dropdown } from "semantic-ui-react";
import { Link, useHistory } from "react-router-dom";
import copy from 'copy-to-clipboard';
import { useMediaQuery } from 'react-responsive';

const ViewOrg = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  // For passing user data to production setup
  const [userData] = useState(sessionStorage.getItem("SessionUserLoginData") ? JSON.parse(sessionStorage.getItem("SessionUserLoginData")) : []);
  const ctx = useContext(ContextData);
  const [orgData, setOrgData] = useState('');
  const [modal, setModal] = useState(false);
  const [modalOrgName, setModalOrgName] = useState();
  const [modalToken, setModalToken] = useState(false);
  // const [modalOrgName,setModalOrgName] = useState(); 
  const [updateToggle, setupdateToggle] = useState(false);
  const [updateUserHeader, setUpdateUserHeader] = useState('');
  const [secondOpen, setSecondOpen] = useState(false);
  const [historyData, setHistoryData] = useState();
  const [remarksUdateMessage, setRemarksUdateMessage] = useState();
  const [remarksOrgId, setRemarksOrgId] = useState();
  const [usersData, setUsersData] = useState();
  const [remarksData, setRemarksData] = useState();
  const [enteredRemarks, setEnteredRemarks] = useState();
  const [charCount, setCharCount] = useState();
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [userRights, setUserRights] = useState(JSON.parse(localStorage.getItem('userRights')));
  //console.log("here is view org initial state //",ctx.userRights, JSON.parse(localStorage.getItem('userRights')));
  //  const [TokenType,setTokenType] = useState(1); 

  const [tokenData, setTokenData] = useState("");
  const [tokenDataError, setTokenDataError] = useState("");
  const [tokenDataCaptain, setTokenDataCaptain] = useState("");
  const [tokenDataCaptainError, setTokenDataCaptainError] = useState("");
  const [webInventory, setWebInventory] = useState("");
  const [webInventoryError, setWebInventoryError] = useState("");

  const [tokenPromis, setTokenPromis] = useState();
  const [outletList, setOutletList] = useState();
  const [propertyId, setPropertyId] = useState();
  const [propertyName, setPropertyName] = useState();
  const [twoCopyStyle, setTwoCopyStyle] = useState();
  const [captainStyle, setCaptainStyle] = useState();
  const [promisStyle, setPromisStyle] = useState();
  const [posSync, setPOSSync] = useState(false);
  //const [POSSyncStatus, setPOSSyncStatus] = useState(false);
  const [addProperty, setAddProperty] = useState();
  const [userType, setUserType] = useState();
  const [Create, setCreate] = useState();
  const [Edit, setEdit] = useState();
  const [View, setView] = useState();
  const [ViewUsers, setViewUsers] = useState();
  const [productLink, setProductLink] = useState();
  const [getToken, setGetToken] = useState();
  const [isCopied, setCopySuccess] = useState(false);


  // console.log(posSync)
  const [propertyOptions, setPropertyOptions] = useState([{
    key: '1',
    text: 'state',
    value: 'add'
  }]);

  // console.log(userRights);
  //const UrlType = 1;
  let history = useHistory();
  const goBack = () => {
    history.push('/');
    setTimeout(() => window.scrollTo(0, 0), 100)
  }

  const remarksInputHandler = (e, data) => {

    setEnteredRemarks(data.value);
    //console.log(data.value);
    setRemarksUdateMessage('');

    var currentText = data.value;
    var characterCount = currentText.length;
    setCharCount(characterCount);

  }

  const historyHandler = () => {

    setSecondOpen(true)
    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetOrganizationRemarksHistory`,
      {
        params: {
          'OrganizationId': remarksOrgId,
          'NoOfRowsPerPage': 25,
          'CurrentPageNumber': 1
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        // console.log('getting remarks history.......,.,');
        // console.log(response.data)
        const data = response.data.response;
        setHistoryData(data);
      })
  }
  const remarksUpdateHandler = () => {
    axios.post(`${process.env.REACT_APP_BASE_API_URL}UpdateOrganizationRemarks`, {
      "OrganizationId": remarksOrgId,
      "Remarks": enteredRemarks,
    },
      {
        headers: { Authorization: `Bearer ${ctx.APIToken}` },
        "Content-Type": "application/json"
      })
      .then((response) => {
        //console.log(response.data);
        setRemarksUdateMessage('Updated Successfully')
      })
  }
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetOrganizationDetails`,
      {
        params: {
          'OrganizationId': props.orgId
        }, headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        // console.log(response.data);
        const data = response.data.response;
        setOrgData(data)
        // history.push('/NewProperty');
      })
    localStorage.removeItem("selectedModules");
    sessionStorage.removeItem('SessionOrgDetails');
    sessionStorage.removeItem('newProperty');
    localStorage.removeItem('defaultUsers');
    sessionStorage.removeItem('newModulesforedit');
    sessionStorage.removeItem('newModulesFeatures');
    sessionStorage.removeItem('newSubModules');
    sessionStorage.removeItem('sessionProperty');
  }, [ctx.APIToken, props.orgId])


  const addPropertyHandler = () => {
    localStorage.removeItem('editData');
    localStorage.setItem('orgAddProperty', JSON.stringify(orgData));
    localStorage.removeItem('editProperty');
    localStorage.removeItem("selectedModules");
    sessionStorage.removeItem('SessionOrgDetails');
    sessionStorage.removeItem('newProperty');
    localStorage.removeItem('defaultUsers');
    sessionStorage.removeItem('newModulesforedit');
    sessionStorage.removeItem('newModulesFeatures');
    sessionStorage.removeItem('newSubModules');
    sessionStorage.removeItem('sessionProperty');
    history.push('/NewProperty');
  }

  //   const editHandler = () =>{ 
  //   axios.get(`${process.env.REACT_APP_BASE_API_URL}GetOrganizationDetails`,
  //   { params: {
  //    'OrganizationId': orgData && orgData.organizationDetails.organizationId
  //   },  headers: { Authorization: `Bearer ${ctx.APIToken}`}},  
  //   )
  //  .then((response)=>{
  //     //   console.log(response.data);
  //        const data = response.data.response;
  //        localStorage.setItem('editData',JSON.stringify(data));
  //      //  history.push('/NewOrganization');
  //  })         
  // } 

  // const editPropertyHandler = (propId) =>{  


  //   }
  const remarksHandler = () => {
    setModal(true);
    setRemarksData(() => '');
    setRemarksUdateMessage('');
    setUpdateUserHeader(() => '');
    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetOrganizationRemarks`,
      {
        params: {
          'OrganizationId': orgData && orgData.organizationDetails.organizationId
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        //console.log('Remarks Data for Remarks');
        // console.log(response.data);
        const data = response.data.response;
        setRemarksData(data);
        if (data.remarksDetails.remarks === '') {
          setUpdateUserHeader('');
          setupdateToggle(false);
        }
        else {
          setupdateToggle(true);
          data.remarksDetails &&
            setUpdateUserHeader(` Laste Update |${data.remarksDetails.lastUpdatedDateTime}
        | By ${data.remarksDetails.lastUpdatedUser}`);
        }
      })
    setModalOrgName(orgData && orgData.organizationDetails.organizationName);
    setRemarksOrgId(orgData && orgData.organizationDetails.organizationId);

  }
  const usersHandler = () => {
    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetOrganizationUserList`,
      {
        params: {
          'OrganizationId': orgData && orgData.organizationDetails.organizationId
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        const data = response.data.response;
        setUsersData(data);
      })
    setModalOrgName(orgData && orgData.organizationDetails.organizationName);
    setOpen(true);
  }
  useEffect(() => {

    setUserRights(() => ctx.userRights)
    // console.log('view org session user rights',ctx.userRights )

  }, [])

  useEffect(() => {
    userRights &&
      userRights.forEach((element) => {
        // console.log('element view org .....',element); 
        element.userType && setUserType(element.userType)
        element.Create && setCreate(element.Create)
        element.Edit && setEdit(element.Edit)
        element.View && setView(element.View)
        element.AddProperty && setAddProperty(element.AddProperty)
        element.ViewUsers && setViewUsers(element.ViewUsers)
        element.productLink && setProductLink(element.productLink)
        element.getToken && setGetToken(element.getToken)
      })
  }, [userRights])


  // GET 'https://dev.lucidits.com/LUCIDLicenseManagementAPI/V1/GetToken?PropertyId=10000000131000000002&TokenType=1'




  const tokensHandler = (propertyId, propertyName) => {
    setPropertyId(propertyId);
    setPropertyName(propertyName);
    setTokenPromis('');
    setTokenData("");
    setTokenDataError("");
    setTokenDataCaptain("");
    setTokenDataCaptainError("");
    setWebInventory("");
    setWebInventoryError("");
    // getTokenApi(propertyId)

    // console.log('property id ',propertyId);

    //'https://dev.lucidits.com/LUCIDLicenseManagementAPI/V1/GetPropertyOutletList?PropertyId=10000000131000000002'  
    // axios.get(`${process.env.REACT_APP_BASE_API_URL}GetPropertyOutletList`,
    //   {
    //     params: {
    //       'PropertyId': propertyId,
    //     },
    //     headers: { Authorization: `Bearer ${ctx.APIToken}` }
    //   },
    // )
    //   .then((response) => {
    //     const data = response.data.response;
    //     // console.log('outlet data ',data);
    //     setOutletList(data);
    //   })
    //'https://dev.lucidits.com/LUCIDLicenseManagementAPI/V1/GetPOSSyncStatus?PropertyId=%3C%3CPropertyId%3E%3E'

    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetPOSSyncStatus`,
      {
        params: {
          'PropertyId': propertyId,
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        const data = response.data.response;
        //console.log('POS Sync ',data);
        setPOSSync(data.posSyncStatus);
      })
    setModalToken(true)
  }

  // added by dasprakash on 16-01-2025
  const getTokenApi = (type) => {
    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetToken`,
      {
        params: {
          'PropertyId': propertyId,
          'TokenType': type
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        if (response.data.errorCode === 0) {
          const data = response.data.response;
          // console.log(data);
          switch (type) {
            case 1:
              setTokenData(data);
              break;
            case 2:
              setTokenDataCaptain(data);
              break;
            case 3:
              setWebInventory(data);
            default:
              // Handle default case if necessary
              break;
          }
        }
        else {
          let errorMsg = response.data.message
          switch (type) {
            case 1:
              setTokenDataError(errorMsg);
              break;
            case 2:
              setTokenDataCaptainError(errorMsg);
              break;
            case 3:
              setWebInventoryError(errorMsg);
            default:
              // Handle default case if necessary
              break;
          }
        }
      })
  }
  // 





  //curl --location --request POST 'https://dev.lucidits.com/LUCIDLicenseManagementAPI/V1/UpdatePOSSyncStatus' \

  const posSyncHandler = (e, data) => {
    setPOSSync(() => posSync === true ? false : true)
    axios.post(`${process.env.REACT_APP_BASE_API_URL}UpdatePOSSyncStatus`, {
      'PropertyId': propertyId,
      'POSSyncStatus': (data.checked === true ? true : false)
    },
      { headers: { Authorization: `Bearer ${ctx.APIToken}` } },
    )
      .then((response) => {
        const data = response.data.response;
      })
  }

  const promisposHandler = (e, data) => {
    //  console. log('data value is .........',data.value)
    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetToken`,
      {
        params: {
          'PropertyId': propertyId,
          'OutletCode': data.value,
          'TokenType': 3
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        const data = response.data.response;

        setTokenPromis(data);
      })
  }


  useEffect(() => {
    outletList &&
      setPropertyOptions(outletList.outletList.map((item, id) => {
        return ({
          key: id,
          text: item.outletName,
          value: item.outletCode
        })
      }));

    //  console.log(outletList);
  }, [outletList])



  const lucidPOSHandler = (link) => {
    const orgid = orgData.organizationDetails.organizationId;
    axios.get(`${process.env.REACT_APP_LUCID_API_URL}GetLUCIDApplicationUrl`, {
      params: {
        'OrganizationId': orgid,
        'UrlType': link
      }, headers: { Authorization: `Bearer ${ctx.APIToken}` }
    }
    ).then((response) => {
      const url = response.data.response.url
      window.open(url)
    })

  }
  useEffect(() => {
    if (searchTerm) {
      sessionStorage.setItem('searchItem', searchTerm);
    }

    sessionStorage.getItem('searchItem') &&
      setSearchTerm(sessionStorage.getItem('searchItem'));
  }, [searchTerm])


  useEffect(() => {
    localStorage.removeItem('editProperty');
    localStorage.removeItem('orgAddProperty');
    localStorage.removeItem('editData');
    localStorage.removeItem("selectedModules");
    sessionStorage.removeItem('SessionOrgDetails');
    sessionStorage.removeItem('newProperty');
    localStorage.removeItem('defaultUsers');
    sessionStorage.removeItem('newModulesforedit');
    sessionStorage.removeItem('newModulesFeatures');
    sessionStorage.removeItem('newSubModules');
    sessionStorage.removeItem('sessionProperty');
  }, [])

  const lucidProductSetupHandler = () => {

    axios.get(`${process.env.REACT_APP_BASE_API_URL}GetUserManagementToken`,
      {
        params: {
          'OrganizationId': orgData.organizationDetails.organizationId
        },
        headers: { Authorization: `Bearer ${ctx.APIToken}` }
      },
    )
      .then((response) => {
        //const data = response.data.response;
        //setUsersData(data);
        if (response.data.errorCode === 1) alert(response.data.message)
        console.log(response.data)
        if (response.data.errorCode === 0) {
          console.log(orgData.organizationDetails)

          const params = {
            token: response.data.response.token,
            imageUrl: orgData.organizationDetails.imageUrl,
            orgName: orgData.organizationDetails.organizationName,
            userName: userData.response.userName,
            userType: userData.response.userType,
            serverDate: userData.response.serverDate
          }
          const searchParams = new URLSearchParams(params);
          console.log("searchParams", searchParams)
          // const encoded = encodeURI(`http://localhost:3000/?${(searchParams)}`);
          // for development mode
          const encoded = encodeURI(`https://devsetup.lucidtest.in/?${(searchParams)}`);
          // for local testing
          // const encoded = encodeURI(`http://localhost:8090/?${(searchParams)}`);
          // const encoded = encodeURI(`http://localhost:4545/?${(searchParams)}`);
          // for production
          // const encoded = encodeURI(`https://setup.lucidpos.com/?${(searchParams)}`);
          window.open(encoded, '_blank')
        }
      })
  }

  const handleDashboardClick = async (orgId) => {
    Promise.all([getOrganizationDetails(orgId), getUserManagementToken(orgId)])
      .then(([organizationDetails, userManagement]) => {
        const organizationParams = {
          OrganizationId: organizationDetails.organizationDetails.organizationId,
          OrganizationName: organizationDetails.organizationDetails.organizationName,
          OrganizationImage: organizationDetails.organizationDetails.imageUrl,
          OrganizationToken: userManagement.token,
          userId:userManagement.userId
        }
        const UserName = JSON.parse(sessionStorage.getItem('SessionUserLoginData')).response.userName;
        const searchParams = new URLSearchParams(organizationParams);
        searchParams.append('UserName', UserName);
        const encoded = encodeURI(`${process.env.REACT_APP_DashboardUrl}?${(searchParams)}`);
        window.open(encoded, '_blank');
      })
  }


  const getOrganizationDetails = async (orgId) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}GetOrganizationDetails`, {
      params: {
        'OrganizationId': orgId
      }, headers: { Authorization: `Bearer ${ctx.APIToken}` }
    })
    return response.data.response;
  }


  const getUserManagementToken = async (orgId) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}GetUserManagementToken`, {
      params: {
        'OrganizationId': orgId
      },
      headers: { Authorization: `Bearer ${ctx.APIToken}` }
    })
    return response.data.response;
  }

  return (
    <Container style={{ minHeight: '100px' }}>
      <Grid>
        <Grid.Row columns={3} className='row-container-vieworg' style={isTabletOrMobile ? { paddingTop: '3%', paddingBottom: '50px', height: '20%' } : { paddingTop: '55px', paddingBottom: '10px', height: '230px' }}>
          <Grid.Column width={2}>
            {orgData && (orgData.organizationDetails.imageUrl && <Image
              rounded
              size='small'
              src={orgData && orgData.organizationDetails.imageUrl}
            />) || <Icon name='picture' size='massive' style={{ marginRight: '1px' }} />
            }
          </Grid.Column>
          <Grid.Column width={8}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ float: 'left', marginRight: '5px' }}> <h3 >{orgData && orgData.organizationDetails.organizationName} </h3></div>
              <div style={{ color: 'green', float: 'left' ,marginRight:"10px"}}>Active</div>
              {
                (Edit || userType === 2) &&
                <li
                  onClick={() => history.push({
                    pathname: "/NewOrganization",
                    state: {
                      ViewOrg: true,
                      OrganizationId: orgData && orgData.organizationDetails.organizationId
                    }
                  })}
                  className="viewOrg-Remarks"
                  key='Edit'
                >
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5595 2.99708C2.62341 2.99682 2.68733 2.99652 2.75124 2.99618C2.92368 2.9954 3.09611 2.99529 3.26854 2.99536C3.41287 2.99536 3.5572 2.99506 3.70154 2.99477C4.0421 2.9941 4.38266 2.99399 4.72322 2.99423C5.0739 2.99446 5.42457 2.99366 5.77525 2.99236C6.07711 2.99128 6.37897 2.99088 6.68084 2.99101C6.86079 2.99109 7.04074 2.9909 7.2207 2.99003C7.38986 2.98925 7.559 2.98932 7.72817 2.99003C7.79004 2.99015 7.85192 2.98997 7.91379 2.98947C8.54385 2.98469 8.54385 2.98469 8.80754 3.18762C9.00729 3.40002 9.03139 3.59908 9.02796 3.88031C9.01181 4.07782 8.95581 4.20594 8.8096 4.34009C8.61834 4.48944 8.48769 4.52793 8.24301 4.52841C8.20488 4.52856 8.20488 4.52856 8.16598 4.52871C8.08056 4.52901 7.99515 4.52905 7.90974 4.52911C7.84858 4.52927 7.78743 4.52945 7.72627 4.52965C7.59443 4.53004 7.46258 4.53034 7.33073 4.53057C7.12212 4.53094 6.9135 4.53165 6.70488 4.53243C6.1116 4.53461 5.51831 4.53651 4.92503 4.53767C4.59747 4.53832 4.26992 4.53934 3.94236 4.54077C3.76907 4.54151 3.59577 4.54205 3.42248 4.54213C3.25932 4.54221 3.09617 4.54277 2.93302 4.54369C2.87329 4.54394 2.81356 4.54402 2.75382 4.5439C2.3651 4.54324 2.03651 4.54919 1.72383 4.80522C1.54277 5.04398 1.55031 5.30912 1.55196 5.59538C1.5518 5.6392 1.55163 5.68303 1.55146 5.72819C1.55112 5.84927 1.55124 5.97034 1.55157 6.09142C1.55181 6.22222 1.55144 6.35302 1.55115 6.48382C1.55068 6.73984 1.55078 6.99585 1.55109 7.25186C1.55132 7.45996 1.55136 7.66806 1.55124 7.87617C1.55123 7.90581 1.55121 7.93545 1.55119 7.96599C1.55116 8.0262 1.55112 8.08642 1.55109 8.14664C1.55079 8.71103 1.55113 9.27543 1.5517 9.83982C1.55217 10.3239 1.55209 10.808 1.5516 11.292C1.55104 11.8545 1.55082 12.4169 1.55114 12.9793C1.55118 13.0393 1.55121 13.0992 1.55124 13.1592C1.55126 13.1888 1.55127 13.2183 1.55129 13.2487C1.55138 13.4565 1.55123 13.6643 1.55098 13.8721C1.55068 14.1254 1.55076 14.3787 1.55133 14.632C1.5516 14.7612 1.55171 14.8904 1.55136 15.0196C1.55099 15.1598 1.55144 15.2999 1.55196 15.44C1.55173 15.4807 1.55149 15.5214 1.55125 15.5634C1.55321 15.8328 1.57436 16.046 1.75432 16.2592C1.94814 16.4207 2.09684 16.481 2.34699 16.4813C2.40318 16.4815 2.40318 16.4815 2.4605 16.4817C2.50162 16.4817 2.54274 16.4817 2.5851 16.4816C2.62881 16.4817 2.67252 16.4818 2.71755 16.4819C2.83895 16.4822 2.96034 16.4823 3.08174 16.4823C3.21264 16.4824 3.34353 16.4826 3.47443 16.4829C3.7607 16.4834 4.04696 16.4836 4.33322 16.4837C4.51197 16.4838 4.69072 16.484 4.86946 16.4841C5.36437 16.4846 5.85927 16.4849 6.35417 16.485C6.38585 16.485 6.41752 16.4851 6.45015 16.4851C6.4819 16.4851 6.51366 16.4851 6.54637 16.4851C6.61071 16.4851 6.67505 16.4851 6.73938 16.4851C6.7713 16.4851 6.80321 16.4851 6.83609 16.4852C7.3532 16.4853 7.87031 16.4859 8.38742 16.4867C8.91834 16.4876 9.44926 16.488 9.98018 16.488C10.2783 16.4881 10.5764 16.4883 10.8744 16.4889C11.1283 16.4895 11.3821 16.4896 11.6359 16.4893C11.7654 16.4892 11.8949 16.4892 12.0244 16.4897C12.1648 16.4903 12.3053 16.49 12.4457 16.4896C12.4865 16.4899 12.5273 16.4902 12.5694 16.4905C12.8235 16.4889 13.0375 16.4708 13.2457 16.3105C13.2647 16.2885 13.2836 16.2665 13.3031 16.2438C13.3226 16.2223 13.3421 16.2008 13.3622 16.1787C13.5341 15.8785 13.4929 15.5021 13.4917 15.1677C13.4918 15.1064 13.4919 15.0452 13.492 14.9839C13.4921 14.8525 13.4921 14.7212 13.4919 14.5898C13.4916 14.3819 13.492 14.174 13.4925 13.9661C13.4938 13.3752 13.4945 12.7842 13.4941 12.1932C13.4938 11.8664 13.4942 11.5397 13.4953 11.2129C13.496 11.0064 13.4959 10.7999 13.4952 10.5933C13.495 10.4648 13.4954 10.3362 13.4961 10.2076C13.4963 10.1481 13.4962 10.0887 13.4958 10.0292C13.4917 9.44607 13.4917 9.44607 13.6943 9.2345C13.9147 9.0302 14.0841 9.00715 14.3804 9.01299C14.5436 9.02708 14.6598 9.0552 14.7841 9.16419C14.9642 9.38351 15.0355 9.55975 15.0351 9.84258C15.0353 9.88207 15.0353 9.88207 15.0355 9.92236C15.0358 10.0108 15.0358 10.0993 15.0359 10.1878C15.036 10.2512 15.0362 10.3145 15.0364 10.3779C15.0369 10.5503 15.0371 10.7226 15.0372 10.895C15.0373 11.0028 15.0375 11.1106 15.0376 11.2184C15.0381 11.556 15.0385 11.8936 15.0386 12.2311C15.0388 12.6202 15.0394 13.0093 15.0404 13.3984C15.0412 13.6994 15.0415 14.0005 15.0416 14.3015C15.0416 14.4811 15.0418 14.6607 15.0424 14.8404C15.043 15.0096 15.0431 15.1789 15.0428 15.3482C15.0427 15.41 15.0429 15.4718 15.0432 15.5337C15.047 16.2425 14.9045 16.8615 14.3974 17.3907C14.0742 17.7004 13.5937 17.9968 13.1361 17.9974C13.0954 17.9977 13.0547 17.9979 13.0127 17.9981C12.9683 17.998 12.9239 17.9979 12.8782 17.9978C12.8303 17.9979 12.7823 17.9981 12.7344 17.9983C12.603 17.9987 12.4715 17.9987 12.3401 17.9986C12.1982 17.9986 12.0564 17.999 11.9145 17.9993C11.6367 17.9999 11.3588 18.0001 11.0809 18.0002C10.855 18.0002 10.6291 18.0003 10.4032 18.0006C9.76243 18.0012 9.12169 18.0015 8.48095 18.0014C8.42914 18.0014 8.42914 18.0014 8.37629 18.0014C8.34171 18.0014 8.30713 18.0014 8.2715 18.0014C7.71127 18.0014 7.15104 18.0021 6.59081 18.0031C6.01536 18.0041 5.4399 18.0046 4.86445 18.0045C4.54146 18.0045 4.21848 18.0047 3.89549 18.0054C3.62045 18.0061 3.34541 18.0062 3.07037 18.0057C2.93012 18.0055 2.78988 18.0055 2.64964 18.0061C2.52105 18.0067 2.39248 18.0066 2.2639 18.006C2.19576 18.0058 2.12762 18.0063 2.05948 18.0069C1.78608 18.0047 1.56905 17.9588 1.31926 17.8478C1.28378 17.8325 1.24829 17.8172 1.21173 17.8015C0.661857 17.5135 0.30411 17.0549 0.0887924 16.4767C0.0111147 16.228 0.00841978 15.9945 0.0090782 15.7352C0.00891891 15.689 0.00875953 15.6429 0.00859541 15.5954C0.0081668 15.4679 0.00817465 15.3404 0.00825772 15.213C0.0082721 15.0752 0.00788351 14.9375 0.00755042 14.7998C0.00696715 14.5302 0.00677319 14.2606 0.00673395 13.991C0.0067005 13.7717 0.00655565 13.5524 0.00633296 13.3331C0.00571392 12.7109 0.00538944 12.0886 0.0054422 11.4663C0.00544501 11.4328 0.00544789 11.3992 0.00545079 11.3647C0.00545366 11.3311 0.00545641 11.2976 0.00545937 11.263C0.00548793 10.7193 0.00481547 10.1756 0.00382376 9.63196C0.00281251 9.07315 0.00232837 8.51434 0.00238904 7.95553C0.00241234 7.64203 0.00222118 7.32854 0.00146261 7.01504C0.000820702 6.74806 0.000670637 6.48108 0.00114664 6.21409C0.00137539 6.07803 0.00138338 5.94198 0.00077033 5.80592C0.000213465 5.68104 0.000321877 5.55618 0.000930995 5.4313C0.0010883 5.36541 0.000561715 5.29952 0 5.23363C0.00491669 4.62177 0.236589 4.09057 0.651292 3.64465C1.19755 3.11933 1.83054 2.99568 2.5595 2.99708Z" fill="#DB2828" />
                    <path d="M12.9564 2.37891C13.0582 2.42792 13.1314 2.47485 13.2114 2.5551C13.244 2.58764 13.244 2.58764 13.2774 2.62083C13.3009 2.64458 13.3244 2.66832 13.3486 2.69279C13.3736 2.71783 13.3987 2.74287 13.4245 2.76867C13.5072 2.85145 13.5897 2.93446 13.6722 3.01749C13.7295 3.07494 13.7868 3.13238 13.8442 3.1898C13.9951 3.34096 14.1457 3.49233 14.2964 3.64374C14.4501 3.79821 14.6041 3.95249 14.758 4.10678C15.06 4.40953 15.3618 4.71251 15.6634 5.01562C15.618 5.11531 15.5703 5.18793 15.4932 5.2655C15.4625 5.29668 15.4625 5.29668 15.4311 5.3285C15.4086 5.35099 15.386 5.37349 15.3628 5.39668C15.3269 5.43292 15.3269 5.43292 15.2903 5.4699C15.2099 5.55101 15.1292 5.63186 15.0485 5.71272C14.9909 5.77074 14.9333 5.82878 14.8756 5.88683C14.7189 6.04463 14.562 6.20219 14.4049 6.35968C14.3068 6.45807 14.2087 6.5565 14.1107 6.65494C13.839 6.92761 13.5673 7.20022 13.2953 7.47257C13.2779 7.49 13.2605 7.50742 13.2426 7.52538C13.2251 7.54284 13.2077 7.56031 13.1897 7.57831C13.1544 7.6137 13.119 7.64909 13.0837 7.68449C13.0662 7.70204 13.0486 7.7196 13.0306 7.73769C12.7467 8.02203 12.4633 8.30691 12.1801 8.59201C11.8892 8.88491 11.5979 9.17734 11.3061 9.46932C11.1423 9.63319 10.9788 9.79726 10.8157 9.96183C10.6623 10.1167 10.5082 10.2709 10.3538 10.4247C10.2972 10.4812 10.2409 10.5379 10.1848 10.5948C10.1081 10.6726 10.0306 10.7497 9.95289 10.8265C9.93098 10.8491 9.90907 10.8717 9.8865 10.895C9.7201 11.0572 9.56046 11.1182 9.3353 11.168C9.29062 11.1784 9.24595 11.1888 9.19992 11.1996C9.1571 11.2082 9.11428 11.2168 9.07016 11.2257C9.04616 11.2306 9.02216 11.2354 8.99743 11.2404C8.91952 11.2562 8.84157 11.2717 8.7636 11.2872C8.70873 11.2981 8.65386 11.3091 8.59899 11.3201C8.48463 11.3429 8.37025 11.3656 8.25585 11.3881C8.10967 11.417 7.9636 11.4464 7.81755 11.476C7.70454 11.4988 7.59145 11.5212 7.47834 11.5435C7.42445 11.5542 7.37058 11.565 7.31675 11.5759C7.24147 11.5912 7.1661 11.606 7.0907 11.6206C7.04796 11.6291 7.00523 11.6376 6.9612 11.6464C6.77895 11.6669 6.64275 11.6606 6.49204 11.5525C6.3742 11.3896 6.37524 11.2289 6.39726 11.0355C6.40603 10.9893 6.41528 10.9433 6.42492 10.8973C6.42989 10.8719 6.43486 10.8465 6.43998 10.8203C6.45635 10.7372 6.47335 10.6542 6.49039 10.5711C6.50204 10.5129 6.51366 10.4547 6.52525 10.3965C6.54957 10.2749 6.57419 10.1533 6.59904 10.0318C6.63079 9.87643 6.66188 9.72092 6.69276 9.56536C6.71666 9.44527 6.74086 9.32525 6.76516 9.20524C6.77673 9.14793 6.78822 9.09061 6.79963 9.03327C6.81565 8.95304 6.83206 8.8729 6.84858 8.79278C6.85549 8.75759 6.85549 8.75759 6.86254 8.7217C6.92236 8.43676 7.05161 8.26829 7.25323 8.06939C7.27758 8.04495 7.30193 8.0205 7.32702 7.99532C7.40856 7.91362 7.49046 7.83229 7.57236 7.75096C7.63094 7.69242 7.68949 7.63385 7.74802 7.57526C7.90692 7.41633 8.06614 7.25773 8.22542 7.09918C8.37499 6.95021 8.52431 6.80099 8.67363 6.65178C8.96935 6.3563 9.26529 6.06105 9.56139 5.76596C9.84896 5.47935 10.1364 5.19263 10.4237 4.90576C10.4415 4.88807 10.4592 4.87038 10.4774 4.85215C10.5663 4.76339 10.6552 4.67464 10.7441 4.58588C11.4812 3.84988 12.2187 3.11427 12.9564 2.37891Z" fill="#DB2828" />
                    <path d="M17.1682 0.279243C17.5697 0.554249 17.8646 0.92682 17.9953 1.40053C18.0902 1.95436 18.0404 2.47988 17.7307 2.95782C17.4945 3.29153 17.1808 3.57351 16.8914 3.86079C16.8504 3.90152 16.8095 3.94226 16.7687 3.98301C16.6698 4.08152 16.5708 4.17993 16.4717 4.27827C16.3689 4.23185 16.2962 4.18179 16.2167 4.10207C16.1949 4.08038 16.1731 4.05869 16.1507 4.03634C16.1272 4.01259 16.1037 3.98885 16.0795 3.96438C16.0545 3.93934 16.0294 3.9143 16.0036 3.8885C15.9209 3.80573 15.8384 3.72271 15.7559 3.63969C15.6986 3.58223 15.6413 3.52479 15.5839 3.46737C15.433 3.31621 15.2823 3.16485 15.1317 3.01344C14.978 2.85896 14.824 2.70468 14.6701 2.55039C14.3681 2.24764 14.0663 1.94466 13.7646 1.64155C13.8121 1.54331 13.8569 1.46994 13.9336 1.39205C13.9535 1.37174 13.9733 1.35142 13.9938 1.3305C14.0153 1.30893 14.0368 1.28735 14.0589 1.26513C14.0925 1.23119 14.0925 1.23119 14.1268 1.19656C14.1743 1.14869 14.2219 1.10091 14.2696 1.05322C14.3415 0.981159 14.4129 0.908557 14.4842 0.835906C15.2175 0.0962141 16.19 -0.303926 17.1682 0.279243Z" fill="#DB2828" />
                  </svg>

                </li>
              }
              <li
                onClick={() => handleDashboardClick(orgData.organizationDetails.organizationId)}
                className="viewOrg-Remarks">
                {(productLink || userType === 2) &&
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.400391" y="0.398438" width="8.71005" height="10.1597" rx="1" stroke="black" stroke-width="0.8" stroke-linejoin="round" />
                    <rect x="0.400391" y="13.1406" width="8.71005" height="7.25689" rx="1" stroke="black" stroke-width="0.8" stroke-linejoin="round" />
                    <rect x="11.6904" y="0.398438" width="8.71005" height="7.25689" rx="1" stroke="black" stroke-width="0.8" stroke-linejoin="round" />
                    <rect x="11.6904" y="10.2383" width="8.71005" height="10.1597" rx="1" stroke="black" stroke-width="0.8" stroke-linejoin="round" />
                  </svg>
                }
              </li>
              <li className="viewOrg-Remarks" onClick={usersHandler}>
                {(ViewUsers === true || userType === 2) &&
                  <svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.8224 8.03354C10.8641 8.06214 10.9059 8.09074 10.9489 8.12021C10.997 8.15237 11.0452 8.18454 11.0949 8.21768C11.1483 8.25449 11.2018 8.29129 11.2569 8.32922C12.4245 9.09638 13.7059 9.37627 15.0667 9.08486C15.7289 8.91902 16.458 8.6399 16.9731 8.16668C17.1256 8.0559 17.1256 8.0559 17.2811 8.05992C18.6907 8.60306 19.7978 10.1007 20.4239 11.452C20.9029 12.5356 21.2877 13.9508 20.9003 15.122C20.7297 15.4712 20.449 15.7328 20.1113 15.9062C19.8885 15.9811 19.6807 15.9843 19.449 15.9832C19.4007 15.9835 19.3524 15.9838 19.3026 15.9841C19.1409 15.9849 18.9792 15.9848 18.8175 15.9847C18.7015 15.9851 18.5855 15.9855 18.4695 15.986C18.1544 15.9872 17.8394 15.9875 17.5243 15.9875C17.3274 15.9876 17.1305 15.9879 16.9336 15.9882C16.2465 15.9894 15.5595 15.99 14.8724 15.9899C14.2322 15.9898 13.5921 15.9911 12.9519 15.9932C12.4021 15.9949 11.8522 15.9955 11.3024 15.9955C10.9741 15.9954 10.6458 15.9958 10.3175 15.9972C10.0086 15.9984 9.69979 15.9984 9.39093 15.9975C9.27775 15.9973 9.16457 15.9976 9.0514 15.9984C8.89651 15.9994 8.7417 15.9988 8.58682 15.9978C8.54236 15.9985 8.4979 15.9992 8.4521 15.9998C8.05327 15.9942 7.73659 15.8505 7.43983 15.5824C6.95158 14.9744 6.92757 14.4309 6.98701 13.6589C7.18283 11.8033 8.08822 9.98778 9.50192 8.81029C10.5851 7.95266 10.5851 7.95266 10.8224 8.03354Z" fill="#2185D0" />
                    <path d="M13.9638 0.000487695C14.0268 0.00118716 14.0897 0.00188663 14.1546 0.00260729C15.2898 0.027642 16.2224 0.500459 17.0168 1.33819C17.8729 2.34261 18.0543 3.44164 18.0044 4.73955C17.9783 5.10056 17.8833 5.41642 17.7424 5.74819C17.7107 5.83026 17.7107 5.83026 17.6783 5.91399C17.2084 7.01022 16.2613 7.70541 15.206 8.12992C14.2361 8.43832 13.0958 8.34344 12.1837 7.9066C11.1108 7.31378 10.4115 6.38411 10.0609 5.189C9.79015 4.02143 10.0538 2.83887 10.6298 1.82528C11.4081 0.642228 12.5751 -0.0205874 13.9638 0.000487695Z" fill="#2185D0" />
                    <path d="M20.11 7.62891C20.3393 7.73489 20.5281 7.88177 20.73 8.03486C21.6038 8.6722 22.6092 8.89916 23.6663 8.72218C24.3618 8.56651 24.9732 8.29802 25.5101 7.804C25.6629 7.69322 25.6629 7.69322 25.7886 7.69523C26.7061 8.1569 27.3732 9.19819 27.714 10.1531C27.7596 10.2973 27.8039 10.442 27.8466 10.5872C27.8696 10.6588 27.8696 10.6588 27.8931 10.7319C27.9848 11.0654 27.9879 11.4083 27.9947 11.7528C27.9964 11.802 27.998 11.8511 27.9997 11.9018C28.0008 12.2989 27.9061 12.5716 27.6359 12.8679C27.2812 13.1968 26.9214 13.2431 26.4609 13.2385C26.411 13.2385 26.361 13.2385 26.3096 13.2385C26.1455 13.2384 25.9814 13.2374 25.8174 13.2364C25.7032 13.2362 25.589 13.236 25.4749 13.2359C25.1752 13.2354 24.8755 13.2341 24.5758 13.2327C24.2696 13.2314 23.9635 13.2308 23.6573 13.2302C23.0572 13.2288 22.4571 13.2266 21.857 13.2239C21.8315 13.1175 21.8315 13.1175 21.8055 13.009C21.7829 12.9152 21.7603 12.8214 21.7377 12.7276C21.7266 12.681 21.7154 12.6344 21.7039 12.5863C21.3128 10.9651 20.4769 9.65433 19.3613 8.46494C19.458 8.21516 19.6112 8.07716 19.8059 7.90222C19.8626 7.85083 19.9194 7.79943 19.9779 7.74647C20.0433 7.68828 20.0433 7.68828 20.11 7.62891Z" fill="#2185D0" />
                    <path d="M2.21133 7.62891C2.23867 7.65154 2.26602 7.67417 2.29419 7.69749C3.17843 8.40699 4.18223 8.88468 5.32956 8.77465C6.30351 8.64784 7.01985 8.26618 7.76417 7.62891C7.99278 7.76159 8.18253 7.90922 8.37638 8.09113C8.42568 8.13714 8.47499 8.18315 8.52578 8.23056C8.5627 8.26546 8.59961 8.30036 8.63765 8.33632C8.58875 8.39468 8.53985 8.45304 8.48947 8.51317C8.45512 8.55487 8.42078 8.59657 8.3854 8.63953C8.29927 8.74319 8.21189 8.84576 8.12365 8.94751C7.2261 10.0084 6.66572 11.1986 6.31673 12.5516C6.29978 12.6166 6.28282 12.6815 6.26535 12.7484C6.22401 12.9069 6.1829 13.0653 6.14199 13.2239C5.48356 13.2284 4.82513 13.2318 4.16668 13.2339C3.86091 13.2349 3.55515 13.2362 3.24938 13.2384C2.95406 13.2405 2.65876 13.2417 2.36344 13.2422C2.251 13.2425 2.13857 13.2432 2.02614 13.2443C1.86815 13.2457 1.7102 13.2459 1.5522 13.2458C1.50615 13.2465 1.46011 13.2472 1.41267 13.2479C1.00729 13.2454 0.667884 13.1538 0.351284 12.8782C0.0608953 12.519 -0.00538755 12.2797 0.000331748 11.8211C0.000894733 11.7671 0.00145772 11.713 0.00203776 11.6574C0.0402741 10.2075 0.701256 9.02509 1.68856 8.02607C1.85473 7.86941 2.01689 7.74494 2.21133 7.62891Z" fill="#2185D0" />
                    <path d="M6.86149 2.41429C7.43151 2.91151 7.78547 3.52795 7.94505 4.28104C8.00112 5.22848 7.92292 5.98144 7.33722 6.75446C6.73989 7.44685 5.96307 7.81183 5.07212 7.8942C4.29096 7.92158 3.58806 7.61481 2.99663 7.09862C2.41554 6.5247 2.08813 5.8753 2.05527 5.04629C2.03961 4.08367 2.33795 3.28659 2.95763 2.56074C4.02988 1.52538 5.71302 1.52733 6.86149 2.41429Z" fill="#2185D0" />
                    <path d="M24.8381 2.41298C25.4244 2.92437 25.8468 3.60671 25.9359 4.40729C25.9986 5.28287 25.8521 6.05219 25.3138 6.75542C24.7343 7.41793 23.9811 7.81272 23.1141 7.88109C22.1654 7.90031 21.4771 7.57493 20.7958 6.91468C20.2285 6.31138 20.0386 5.59808 20.0371 4.77988C20.051 3.94645 20.3614 3.21385 20.8992 2.59562C21.9817 1.53979 23.6625 1.50503 24.8381 2.41298Z" fill="#2185D0" />
                  </svg>


                }
              </li>
              <li onClick={remarksHandler} className="viewOrg-Remarks">
                <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.200965 3.60938C0.230022 3.6097 0.25908 3.61003 0.289018 3.61036C0.322032 3.61037 0.355046 3.61038 0.38906 3.6104C0.424572 3.61115 0.460083 3.61191 0.49667 3.61269C0.551352 3.613 0.551353 3.613 0.607139 3.61332C0.723678 3.61414 0.840175 3.61598 0.956701 3.61784C1.03566 3.61858 1.11463 3.61925 1.19359 3.61985C1.38727 3.62134 1.58085 3.62421 1.77453 3.62701C1.77453 3.90519 1.77453 4.18338 1.77453 4.47C1.50843 4.47 1.24232 4.47 0.968155 4.47C0.968155 8.81214 0.968155 13.1543 0.968155 17.628C4.65733 17.628 8.34651 17.628 12.1475 17.628C12.1475 13.298 12.1475 8.96791 12.1475 4.50665C11.8814 4.50665 11.6153 4.50665 11.3411 4.50665C11.3411 4.21637 11.3411 3.92608 11.3411 3.62701C11.5701 3.62617 11.7991 3.62544 12.0281 3.62499C12.1061 3.62481 12.1841 3.62456 12.2621 3.62424C12.3739 3.6238 12.4857 3.62359 12.5975 3.62343C12.6501 3.62314 12.6501 3.62314 12.7038 3.62285C12.7522 3.62285 12.7523 3.62285 12.8017 3.62284C12.8302 3.62276 12.8588 3.62268 12.8882 3.6226C12.9539 3.62701 12.9539 3.62701 12.9905 3.66366C12.9942 3.74192 12.9952 3.8203 12.9952 3.89864C12.9953 3.9236 12.9954 3.94856 12.9954 3.97427C12.9956 4.05896 12.9955 4.14364 12.9954 4.22832C12.9955 4.28923 12.9956 4.35013 12.9957 4.41104C12.9959 4.57923 12.9959 4.74741 12.9958 4.91559C12.9958 5.09666 12.996 5.27772 12.9962 5.45878C12.9965 5.81382 12.9966 6.16886 12.9966 6.52389C12.9967 6.81232 12.9967 7.10075 12.9968 7.38918C12.9972 8.20597 12.9973 9.02275 12.9973 9.83954C12.9973 9.90566 12.9973 9.90566 12.9973 9.97311C12.9973 10.0172 12.9973 10.0614 12.9973 10.1068C12.9973 10.8224 12.9976 11.538 12.9982 12.2536C12.9987 12.9875 12.9989 13.7213 12.9989 14.4551C12.9989 14.8675 12.999 15.2799 12.9994 15.6922C12.9997 16.0433 12.9998 16.3943 12.9996 16.7454C12.9994 16.9247 12.9994 17.1039 12.9998 17.2832C13 17.4471 13 17.611 12.9997 17.7749C12.9996 17.8344 12.9997 17.8939 12.9999 17.9534C13.0001 18.0339 12.9999 18.1143 12.9996 18.1947C12.9997 18.262 12.9997 18.262 12.9997 18.3306C12.9905 18.4343 12.9905 18.4343 12.9172 18.5076C12.8262 18.5169 12.8262 18.5169 12.7087 18.5171C12.6418 18.5174 12.6418 18.5174 12.5735 18.5178C12.5235 18.5177 12.4735 18.5176 12.4235 18.5174C12.3707 18.5176 12.318 18.5178 12.2652 18.5179C12.1198 18.5184 11.9743 18.5184 11.8288 18.5183C11.6721 18.5183 11.5155 18.5187 11.3588 18.519C11.0516 18.5196 10.7445 18.5198 10.4373 18.5199C10.1877 18.5199 9.93816 18.5201 9.6886 18.5203C8.98171 18.521 8.27482 18.5213 7.56793 18.5212C7.51072 18.5212 7.51072 18.5212 7.45235 18.5212C7.41417 18.5212 7.37598 18.5212 7.33664 18.5212C6.7175 18.5212 6.09836 18.5219 5.47922 18.5229C4.84414 18.524 4.20906 18.5245 3.57398 18.5244C3.21717 18.5244 2.86036 18.5246 2.50355 18.5254C2.1998 18.5261 1.89605 18.5262 1.5923 18.5257C1.43721 18.5255 1.28213 18.5255 1.12704 18.5261C0.985208 18.5267 0.843395 18.5266 0.701566 18.5259C0.650113 18.5258 0.59866 18.526 0.547208 18.5264C0.47755 18.5269 0.407886 18.5264 0.338228 18.5259C0.29945 18.5259 0.260672 18.5259 0.220719 18.5259C0.125124 18.5076 0.125124 18.5076 0.0576891 18.4485C0.00130306 18.3325 0.00137756 18.2446 0.00132542 18.1156C0.0011656 18.0908 0.00100577 18.0661 0.000841107 18.0406C0.000438328 17.9572 0.00082213 17.8739 0.00119979 17.7906C0.00107314 17.7304 0.000898545 17.6702 0.00067998 17.61C0.000219632 17.4443 0.000448418 17.2786 0.000788412 17.1129C0.00103656 16.9343 0.000653516 16.7557 0.000350786 16.5771C-0.000138961 16.2272 -3.21953e-05 15.8772 0.000286206 15.5272C0.000534227 15.2429 0.000568347 14.9585 0.000448522 14.6741C0.000431672 14.6337 0.000414829 14.5933 0.000397469 14.5517C0.000362313 14.4695 0.000326663 14.3874 0.000290523 14.3053C-2.32676e-05 13.5348 0.000337841 12.7643 0.000928322 11.9938C0.00141962 11.3322 0.0013343 10.6706 0.0008273 10.009C0.000239255 9.24134 6.93356e-06 8.47364 0.000344826 7.70594C0.000379855 7.62413 0.000414419 7.54231 0.000448522 7.4605C0.000465486 7.42024 0.000482445 7.37998 0.000499924 7.33851C0.00059499 7.05439 0.00043435 6.77028 0.000175868 6.48616C-0.000132071 6.14007 -5.00458e-05 5.79398 0.000536627 5.44788C0.000826232 5.27119 0.000937722 5.09451 0.000575201 4.91782C0.00024864 4.75622 0.000425792 4.59463 0.00101258 4.43303C0.00113588 4.37443 0.00107188 4.31583 0.000806309 4.25723C0.000473955 4.17783 0.000812796 4.09846 0.00132542 4.01906C0.00134327 3.97488 0.00136112 3.9307 0.00137951 3.88519C0.0186942 3.74503 0.0551549 3.64327 0.200965 3.60938Z" fill="#2185D0" />
                  <path d="M7.16014 0.131321C7.53796 0.357862 7.80356 0.628997 7.93345 1.05707C7.96735 1.19849 7.97437 1.3294 7.97368 1.4747C7.97356 1.51875 7.97344 1.56281 7.97332 1.6082C7.97302 1.65387 7.97271 1.69953 7.97239 1.74658C7.97223 1.79295 7.97206 1.83932 7.97189 1.8871C7.97146 2.00138 7.97086 2.11565 7.9701 2.22992C7.99817 2.2296 8.02623 2.22927 8.05514 2.22894C8.31993 2.226 8.58471 2.22377 8.84951 2.22233C8.98563 2.22156 9.12175 2.22053 9.25787 2.21886C9.3893 2.21727 9.52071 2.21639 9.65214 2.21601C9.70223 2.21574 9.75231 2.21522 9.80238 2.21442C9.87265 2.21335 9.94293 2.2133 10.0132 2.21328C10.0532 2.21295 10.0931 2.21263 10.1343 2.21229C10.2702 2.23441 10.329 2.28015 10.4259 2.37653C10.7266 2.97794 10.4992 3.71999 10.4992 4.39238C7.88653 4.39238 5.27387 4.39238 2.58203 4.39238C2.58203 2.52314 2.58203 2.52314 2.72865 2.30323C2.85717 2.21755 2.90783 2.22099 3.0597 2.2216C3.12793 2.22161 3.12793 2.22161 3.19755 2.22162C3.24718 2.22199 3.29682 2.22237 3.34646 2.22276C3.39725 2.2229 3.44804 2.22301 3.49884 2.22308C3.63243 2.22336 3.76602 2.22408 3.89961 2.22489C4.03597 2.22564 4.17233 2.22597 4.30869 2.22634C4.57617 2.22713 4.84365 2.22838 5.11113 2.22992C5.11074 2.20389 5.11036 2.17786 5.10996 2.15104C5.10843 2.0315 5.10748 1.91195 5.10654 1.79239C5.10593 1.75145 5.10532 1.71051 5.10468 1.66833C5.1018 1.17733 5.20933 0.758299 5.55011 0.390747C5.97207 0.0111598 6.63748 -0.125067 7.16014 0.131321Z" fill="#2185D0" />
                </svg>
              </li>
            </div>
            <div style={{ clear: 'left', fontSize: '11px' }}>
              {orgData && orgData.organizationDetails.organizationId}
            </div>

            <div><b>Address Details</b>{
              orgData && `${orgData.organizationDetails.address.addressLine1},
                                 ${orgData.organizationDetails.address.addressLine2},
                                 ${orgData.organizationDetails.address.addressLine3}, 
                                 ${orgData.organizationDetails.address.areaName},
                                 ${orgData.organizationDetails.address.cityName},
                                 ${orgData.organizationDetails.address.stateName},
                                 ${orgData.organizationDetails.address.countryName},
                                 ${orgData.organizationDetails.address.zipCode}, 
                                 ${orgData.organizationDetails.address.landmark}`
            }

            </div>
            <div> <b>Contact Details</b>{
              orgData && `${orgData.organizationDetails.contactDetails.mobileNo},
                        ${orgData.organizationDetails.contactDetails.telephoneNo},
                        ${orgData.organizationDetails.contactDetails.emailId},
                        ${orgData.organizationDetails.contactDetails.website}`
            }</div>
          </Grid.Column>
          <Grid.Column>
          </Grid.Column>
          <Grid.Column width={16}>
            <div style={{ float: 'left', padding: '10px', paddingBottom: '0px' }}>
              {/* <li className="viewOrg-Remarks" onClick={usersHandler}>
                {(ViewUsers === true || userType === 2) && 'Users'}
              </li>
              <li onClick={remarksHandler} className="viewOrg-Remarks">
                Remarks
              </li> */}

              <li
                onClick={() => lucidPOSHandler(1)}
                className="viewOrg-Remarks"
              >
                {(productLink || userType === 2) && 'LUCIDPOS'}
              </li>
              <li
                onClick={() => lucidPOSHandler(2)}
                className="viewOrg-Remarks">
                {(productLink || userType === 2) &&
                  'LUCIDOnlineOrders'}
              </li>
              {/* <li
                onClick={lucidProductSetupHandler}
                className="viewOrg-Remarks">
                {(productLink || userType === 2) &&
                  'LucidProductSetup'}
              </li> */}
              {/* <li
                onClick={() => handleDashboardClick(orgData.organizationDetails.organizationId)}
                className="viewOrg-Remarks">
                {(productLink || userType === 2) &&
                  'Dashboard'}
              </li> */}
            </div>
          </Grid.Column>
          <Grid.Column width={12} style={{ backgroundColor: 'white', paddingTop: '10px' }}>
            <div className="addprop-mobile"  >
              <Form>
                <Form.Field inline>
                  <Input
                    value={searchTerm}
                    style={{ marginRight: '10px' }}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      if (e.target.value === '') sessionStorage.removeItem('searchItem');
                    }}
                    icon={searchTerm && <Icon name='delete' link onClick={() => {
                      setSearchTerm('');
                      sessionStorage.removeItem('searchItem');
                    }} />}
                  />
                  <Button color='blue'>Search</Button>
                </Form.Field>

              </Form>
            </div>
            <div style={{ marginRight: '60px' }}>
              {(addProperty || userType === 2) &&
                <Button color='blue' onClick={addPropertyHandler} floated="right">
                  Add Property
                </Button>
              }
            </div>
          </Grid.Column>

        </Grid.Row>
        <Grid.Row className="vcard-section" style={{ marginTop: '40px' }}>
          <Card.Group itemsPerRow={5} className='dash-card-links'
            style={{ paddingTop: '22%' }}>
            {
              orgData &&
              orgData.propertyList.map((field) => {
                if (searchTerm === "") {
                  return field
                } else if (
                  field.propertyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  // added by dasprakash on 26-12-2024
                  field.propertyDisplayName?.toLowerCase().includes(searchTerm.toLowerCase())
                  // 
                ) {
                  return field;
                }
              }).map((field) => {
                if (field) {
                  return (
                    <Card color='grey' key={field.propertyId} style={{ marginLeft: '20px', width: '310px' }}
                    >
                      <Card.Content>
                        {(field.imageUrl && <Image
                          floated='left'
                          style={{ width: '50px' }}
                          src={field.imageUrl}
                        />) || <Icon name='picture' color='grey' size='huge' style={{ float: 'left' }} />
                        }
                        <Card.Meta
                          style={field.status === 1 ? { color: 'green', position: 'absolute', right: '5px', top: '0' } : { color: 'red', position: 'absolute', right: '5px', top: '0' }}
                          floated='right'
                        >{field.status === 1 ? 'Active' : 'Passive'}
                        </Card.Meta>
                        <div
                        >
                          <div style={{ fontSize: '2vh' }}><b>{field.propertyName}</b></div>
                          <div style={{ fontSize: '10px', lineHeight: '5px', marginBottom: '5px' }}>{field.propertyId}</div>
                        </div>
                        <div style={{ fontSize: '2vh' }}>
                          {field.areaName}  {field.cityName}
                        </div>
                      </Card.Content>
                      <Card.Content extra>
                        <div>
                          {(Edit || userType === 2) &&
                            <Link to={{
                              pathname: "/NewProperty",
                              state: {
                                propertyId: field.propertyId,
                                orgName: orgData && orgData.organizationDetails.organizationName,
                                orgId: orgData && orgData.organizationDetails.organizationId
                              }
                            }}

                              style={{ marginRight: '5%' }}
                              key='Edit'
                            >
                              <Icon name='edit' color='red' />
                              <span>  Edit </span>
                            </Link>
                          }
                          {(View || userType === 2) &&
                            <Link to={{
                              pathname: "/ViewPrope",
                              state: {
                                propertyId: field.propertyId,
                                orgName: orgData && orgData.organizationDetails.organizationName
                              }
                            }}
                              color='green'
                              style={{ marginRight: '5%' }}
                              key='View'
                            >
                              <Icon name='eye' color='green' />
                              <span> View </span>
                            </Link>
                          }
                          {(getToken || userType === 2) &&
                            <li onClick={tokensHandler.bind(this, field.propertyId, field.propertyName)}
                              style={{
                                marginRight: '5%',
                                listStyle: 'none',
                                display: 'inline',
                                cursor: 'pointer'
                              }}
                              key='tokens'
                            >
                              <Icon name='ticket' color='blue' />
                              <span> Tokens </span>
                            </li>
                          }
                        </div>
                        <Card.Content extra style={{ fontSize: '10px', color: 'black', borderTop: 'solid 1px', borderTopColor: 'rgb(221, 221, 221)' }}>
                          <div style={{ float: 'left', marginRight: '10px', marginTop: '5px' }}> Created Date: {field.createdDate} </div>
                          <div style={{ marginTop: '5px', wordBreak: 'keep-all' }}> User ID: {field.createdBy}</div>
                        </Card.Content>
                      </Card.Content>
                    </Card>
                  )
                } else return null
              })

            }
          </Card.Group>
        </Grid.Row>
        <Grid.Row style={{ marginBottom: '50px' }}>
          <Grid.Column width={4}>
            <Button
              color='blue'
              onClick={goBack}
            > Go Back</Button>
          </Grid.Column>
          <Grid.Column width={4} floated='right'>

          </Grid.Column>

        </Grid.Row>
      </Grid>

      <Modal style={{ maxWidth: '30%' }}
        closeIcon
        dimmer='blurring'
        open={modal}
        //  trigger={modal}
        onClose={() => setModal(false)}
        onOpen={() => setModal(true)}
      >
        {
          <>
            <Header icon='archive' content={`${modalOrgName} - Remarks`} />
            <div style={{ textAlign: 'center', padding: '5px', paddingTop: '10px', fontSize: '12px', maxWidth: '400px' }}>
              {updateToggle && updateUserHeader
              }
            </div>
            <div style={{ fontSize: '12px', textAlign: 'right', paddingRight: '19px' }}>
              <li onClick={historyHandler} className="viewOrg-Remarks">
                History
              </li>

            </div>
            <Modal.Content  >
              <Form>
                <Form.TextArea
                  label=''
                  placeholder='Remarks'
                  onChange={remarksInputHandler}
                  defaultValue={remarksData && remarksData.remarksDetails.remarks}
                  style={{ height: '200px' }}
                />
              </Form>
              <div style={{ color: 'green', fontSize: '12px', textAlign: 'right' }}> {remarksUdateMessage}</div>
              <div style={{ fontSize: '12px' }}>(Max Char {charCount}/1000)</div>
            </Modal.Content>
          </>
        }
        <Modal.Actions>
          <Button color='blue' onClick={remarksUpdateHandler}>
            <Icon name='save' /> Update
          </Button>

        </Modal.Actions>

        <Modal className='modal-history'
          onClose={() => setSecondOpen(false)}
          open={secondOpen}
          size='tiny'
        >
          <Modal.Header>History</Modal.Header>
          <Modal.Content>
            <div style={{ maxHeight: '260px', overflowY: 'scroll' }}>
              {historyData && historyData.remarksHistory.map((item, idx) => {
                return <> <div key={idx}
                  style={{ fontSize: '12px' }}
                > <b>
                    {` ${item.updatedDateTime} , ${item.updatedUser}`}
                  </b>
                </div>
                  <Form.TextArea disabled value={` ${item.remarks} `} style={{ width: '100%', marginBottom: '20px' }}>
                  </Form.TextArea>
                </>
              })
              }
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button
              icon='check'
              content='Close'
              onClick={() => setSecondOpen(false)}
            />
          </Modal.Actions>
        </Modal>
      </Modal>



      <Modal style={{ maxWidth: '450px' }}
        closeIcon
        dimmer='blurring'
        open={open}
        //trigger={modal}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Header icon='archive' content={`${modalOrgName} - Users`} />
        <Modal.Content >
          <Table celled>
            <Table.Header>
              <Table.Row textAlign='center'>
                <Table.HeaderCell>User Id</Table.HeaderCell>
                <Table.HeaderCell>Password</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {usersData &&
                usersData.users.map((user, idi) => {
                  return (
                    <>
                      <Table.Row key={idi}>
                        <Table.HeaderCell textAlign='center' colSpan={2}> {user.userLevel}</Table.HeaderCell>
                      </Table.Row>
                      {user.userList.map((user, idx) => {
                        return <>
                          <Table.Row key={idx}>
                            <Table.Cell>{user.userId}</Table.Cell>
                            <Table.Cell>{user.password}</Table.Cell>
                          </Table.Row>
                        </>
                      })}
                    </>
                  )
                }
                )}

            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
        </Modal.Actions>
      </Modal>



      {/* token popup */}
      <Modal style={{ maxWidth: '550px' }}
        closeIcon
        dimmer='blurring'
        open={modalToken}
        //  trigger={modal}
        onClose={() => setModalToken(false)}
        onOpen={() => setModalToken(true)}
      >
        <Header
          style={{ position: "relative" }}
          icon='archive'
          content={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
              {`${propertyName} - Tokens`}
            </div>
          }
        />

        <Modal.Content >
          <div >
            {/* TwoWaySync Services Token  */}
            <div style={{ marginBottom: "15px" }}>
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>TwoWaySync Services Token /PROMIS - POS Integration Token</span><br />
              <small style={{ fontSize: '11px', color: '#5C9CE8' }}>[Note: PROMIS-POS Token use to integrate ‘Orders’ , ‘Table Reservation’ , ’E-Bill’ , and ‘Loyalty’]</small>
              <div style={{ paddingLeft: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: "5px", height: "36px", border: tokenDataError !== "" ? "1px solid #FF0000" : "1px solid rgba(0, 0, 0, 0.2)", marginTop: "6px" }}>
                {tokenData !== "" ?
                  <input
                    onKeyDown={(e) => {
                      // Allow navigation keys: ArrowLeft, ArrowRight, Home, End
                      if (
                        ["ArrowLeft", "ArrowRight", "Home", "End", "Tab", "Shift", "Control"].includes(
                          e.key
                        )
                      ) {
                        return;
                      }
                      e.preventDefault(); // Prevent other keys
                    }}
                    onInput={(e) => e.preventDefault()}  // Prevent other input actions
                    onPaste={(e) => e.preventDefault()}  // Prevent pasting
                    onClick={() => {
                      console.log("");
                    }}
                    style={{ backgroundColor: "transparent", outline: "none", fontSize: "12px", cursor: "default", fontWeight: "400", height: "33px", border: "none", width: "90%" }} defaultValue={tokenData.token} />
                  :
                  <span onClick={() => getTokenApi(1)} style={{ width: "100%", marginRight: "10px", textAlign: "end", fontSize: '12px', color: '#5C9CE8', cursor: "pointer" }}>View Token</span>
                }
                {tokenData &&
                  <div onClick={() => copy(tokenData.token)} className="copyBtn" style={{ width: "9%", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", borderLeft: "1px solid rgba(0, 0, 0, 0.2)", height: "36px", }}>
                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.13124 0C2.73312 0 0.789062 1.94406 0.789062 4.34217V9.709C0.789062 10.0218 1.04264 10.2754 1.35543 10.2754C1.66823 10.2754 1.9218 10.0218 1.9218 9.709V4.34217C1.9218 2.56965 3.35872 1.13274 5.13124 1.13274H10.4271C10.7399 1.13274 10.9934 0.879168 10.9934 0.566371C10.9934 0.253573 10.7399 0 10.4271 0H5.13124Z" fill="black" fillOpacity="0.8" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.2317 2.67573C9.78424 2.40219 7.27471 2.40219 4.82727 2.67573C4.13005 2.75366 3.56977 3.30235 3.48759 4.00498C3.19732 6.4868 3.19732 8.99399 3.48759 11.4758C3.56977 12.1784 4.13005 12.7271 4.82727 12.8051C7.27471 13.0786 9.78424 13.0786 12.2317 12.8051C12.9289 12.7271 13.4892 12.1784 13.5714 11.4758C13.8616 8.99399 13.8616 6.4868 13.5714 4.00498C13.4892 3.30235 12.9289 2.75366 12.2317 2.67573ZM4.95309 3.80146C7.31691 3.53727 9.74204 3.53727 12.1059 3.80146C12.2851 3.8215 12.426 3.96324 12.4463 4.13657C12.7263 6.53096 12.7263 8.94983 12.4463 11.3442C12.426 11.5175 12.2851 11.6593 12.1059 11.6793C9.74204 11.9435 7.31691 11.9435 4.95309 11.6793C4.77385 11.6593 4.63293 11.5175 4.61266 11.3442C4.33261 8.94983 4.33261 6.53096 4.61266 4.13657C4.63293 3.96324 4.77385 3.8215 4.95309 3.80146Z" fill="black" fillOpacity="0.8" />
                    </svg>
                  </div>
                }
              </div>
              <span style={{ color: "#FF0000", fontSize: "12px", fontWeight: "400" }}>{tokenDataError}</span>
            </div>
            {/*  */}

            {/* Caption App  */}
            <div style={{ marginBottom: "15px" }}>
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>Caption App - Online order Integration Token</span><br />
              <div style={{ paddingLeft: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: "5px", height: "36px", border: tokenDataCaptainError !== "" ? "1px solid #FF0000" : "1px solid rgba(0, 0, 0, 0.2)", marginTop: "6px" }}>
                {tokenDataCaptain !== "" ?
                  <input
                    onKeyDown={(e) => {
                      // Allow navigation keys: ArrowLeft, ArrowRight, Home, End
                      if (
                        ["ArrowLeft", "ArrowRight", "Home", "End", "Tab", "Shift", "Control"].includes(
                          e.key
                        )
                      ) {
                        return;
                      }
                      e.preventDefault(); // Prevent other keys
                    }}
                    onInput={(e) => e.preventDefault()}  // Prevent other input actions
                    onPaste={(e) => e.preventDefault()}  // Prevent pasting
                    onClick={() => {
                      console.log("");
                    }}
                    style={{ backgroundColor: "transparent", outline: "none", fontSize: "12px", cursor: "default", fontWeight: "400", height: "33px", border: "none", width: "90%" }} defaultValue={tokenDataCaptain.token} />
                  :
                  <span onClick={() => getTokenApi(2)} style={{ width: "100%", marginRight: "10px", textAlign: "end", fontSize: '12px', color: '#5C9CE8', cursor: "pointer" }}>View Token</span>
                }
                {tokenDataCaptain &&
                  <div className="copyBtn" onClick={() => copy(tokenDataCaptain.token)} style={{ width: "9%", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", borderLeft: "1px solid rgba(0, 0, 0, 0.2)", height: "36px", }}>
                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.13124 0C2.73312 0 0.789062 1.94406 0.789062 4.34217V9.709C0.789062 10.0218 1.04264 10.2754 1.35543 10.2754C1.66823 10.2754 1.9218 10.0218 1.9218 9.709V4.34217C1.9218 2.56965 3.35872 1.13274 5.13124 1.13274H10.4271C10.7399 1.13274 10.9934 0.879168 10.9934 0.566371C10.9934 0.253573 10.7399 0 10.4271 0H5.13124Z" fill="black" fillOpacity="0.8" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.2317 2.67573C9.78424 2.40219 7.27471 2.40219 4.82727 2.67573C4.13005 2.75366 3.56977 3.30235 3.48759 4.00498C3.19732 6.4868 3.19732 8.99399 3.48759 11.4758C3.56977 12.1784 4.13005 12.7271 4.82727 12.8051C7.27471 13.0786 9.78424 13.0786 12.2317 12.8051C12.9289 12.7271 13.4892 12.1784 13.5714 11.4758C13.8616 8.99399 13.8616 6.4868 13.5714 4.00498C13.4892 3.30235 12.9289 2.75366 12.2317 2.67573ZM4.95309 3.80146C7.31691 3.53727 9.74204 3.53727 12.1059 3.80146C12.2851 3.8215 12.426 3.96324 12.4463 4.13657C12.7263 6.53096 12.7263 8.94983 12.4463 11.3442C12.426 11.5175 12.2851 11.6593 12.1059 11.6793C9.74204 11.9435 7.31691 11.9435 4.95309 11.6793C4.77385 11.6593 4.63293 11.5175 4.61266 11.3442C4.33261 8.94983 4.33261 6.53096 4.61266 4.13657C4.63293 3.96324 4.77385 3.8215 4.95309 3.80146Z" fill="black" fillOpacity="0.8" />
                    </svg>
                  </div>
                }
              </div>
              <span style={{ color: "#FF0000", fontSize: "12px", fontWeight: "400" }}>{tokenDataCaptainError}</span>
            </div>
            {/*  */}

            {/* Web Inventory */}
            <div style={{ marginBottom: "15px" }}>
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>Web Inventory Menu Sync Token</span><br />
              <div style={{ paddingLeft: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: "5px", height: "36px", border: webInventoryError !== "" ? "1px solid #FF0000" : "1px solid rgba(0, 0, 0, 0.2)", marginTop: "6px" }}>
                {webInventory !== "" ?
                  <input
                    onKeyDown={(e) => {
                      // Allow navigation keys: ArrowLeft, ArrowRight, Home, End
                      if (
                        ["ArrowLeft", "ArrowRight", "Home", "End", "Tab", "Shift", "Control"].includes(
                          e.key
                        )
                      ) {
                        return;
                      }
                      e.preventDefault(); // Prevent other keys
                    }}
                    onInput={(e) => e.preventDefault()}  // Prevent other input actions
                    onPaste={(e) => e.preventDefault()}  // Prevent pasting
                    onClick={() => {
                      console.log("");
                    }}
                    style={{ backgroundColor: "transparent", outline: "none", fontSize: "12px", cursor: "default", fontWeight: "400", height: "33px", border: "none", width: "90%" }} defaultValue={webInventory.token} />
                  :
                  <span onClick={() => getTokenApi(3)} style={{ width: "100%", marginRight: "10px", textAlign: "end", fontSize: '12px', color: '#5C9CE8', cursor: "pointer" }}>View Token</span>
                }
                {webInventory &&
                  <div className="copyBtn" onClick={() => copy(webInventory.token)} style={{ width: "9%", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", borderLeft: "1px solid rgba(0, 0, 0, 0.2)", height: "36px", }}>
                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.13124 0C2.73312 0 0.789062 1.94406 0.789062 4.34217V9.709C0.789062 10.0218 1.04264 10.2754 1.35543 10.2754C1.66823 10.2754 1.9218 10.0218 1.9218 9.709V4.34217C1.9218 2.56965 3.35872 1.13274 5.13124 1.13274H10.4271C10.7399 1.13274 10.9934 0.879168 10.9934 0.566371C10.9934 0.253573 10.7399 0 10.4271 0H5.13124Z" fill="black" fillOpacity="0.8" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.2317 2.67573C9.78424 2.40219 7.27471 2.40219 4.82727 2.67573C4.13005 2.75366 3.56977 3.30235 3.48759 4.00498C3.19732 6.4868 3.19732 8.99399 3.48759 11.4758C3.56977 12.1784 4.13005 12.7271 4.82727 12.8051C7.27471 13.0786 9.78424 13.0786 12.2317 12.8051C12.9289 12.7271 13.4892 12.1784 13.5714 11.4758C13.8616 8.99399 13.8616 6.4868 13.5714 4.00498C13.4892 3.30235 12.9289 2.75366 12.2317 2.67573ZM4.95309 3.80146C7.31691 3.53727 9.74204 3.53727 12.1059 3.80146C12.2851 3.8215 12.426 3.96324 12.4463 4.13657C12.7263 6.53096 12.7263 8.94983 12.4463 11.3442C12.426 11.5175 12.2851 11.6593 12.1059 11.6793C9.74204 11.9435 7.31691 11.9435 4.95309 11.6793C4.77385 11.6593 4.63293 11.5175 4.61266 11.3442C4.33261 8.94983 4.33261 6.53096 4.61266 4.13657C4.63293 3.96324 4.77385 3.8215 4.95309 3.80146Z" fill="black" fillOpacity="0.8" />
                    </svg>
                  </div>
                }
              </div>
              <span style={{ color: "#FF0000", fontSize: "12px", fontWeight: "400" }}>{webInventoryError}</span>
            </div>
            {/*  */}

            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              <small style={{ fontSize: "14px", fontWeight: "600", marginRight: "10px" }}>
                Menu Sync
              </small>
              <Radio
                small
                toggle
                // style={{ float: 'right' }}
                onChange={posSyncHandler}
                checked={Boolean(posSync && posSync)}
              />
            </div>
          </div>



          {/* <div style={{ float: 'left', fontSize: '1.8vh', fontWeight: 'bold' }}>
            TwoWaySync Services Token /PROMIS - POS Integration Token  <br />
            <span style={{ fontSize: '11px', color: '#5C9CE8' }}>
              [Note: PROMIS-POS Token use to integrate 'Table Reservation', 'E-Bill', and 'Loyalty']
            </span>
          </div>
          <div style={{ textAlign: 'right' }}>
            <Icon
              style={{ cursor: 'pointer', ...twoCopyStyle, fontSize: '17px' }}
              onClick={() => {
                setTwoCopyStyle({ color: 'green' })
                setPromisStyle({ color: '' })
                setCaptainStyle({ color: '' });
                copy(tokenData.token);
              }} name='copy outline' textAlign='right'></Icon>
          </div>
          <Form size='mini'>
            <Input
              style={{ marginLeft: '3px', width: '495px' }}
              value={tokenData && tokenData.token}
            />
          </Form>
          <div style={{ float: 'left', marginTop: '25px', fontSize: '1.8vh', fontWeight: 'bold' }}>
            Captain App - Online Order Integration Token
          </div>
          <div style={{ textAlign: 'right', paddingTop: '22px' }}>
            <Icon
              style={{ cursor: 'pointer', ...captainStyle, fontSize: '17px' }}
              onClick={() => {
                setTwoCopyStyle({ color: '' });
                setPromisStyle({ color: '' })
                setCaptainStyle({ color: 'green' });
                copy(tokenDataCaptain.token);
              }} name='copy outline' textAlign='right'></Icon>
          </div>
          <Form size='mini'>

            <Input
              style={{ marginLeft: '3px', width: '495px' }}
              value={tokenDataCaptain && tokenDataCaptain.token}
            />
          </Form> */}




          {/* commented by dasprakash on 16-01-2025 */}
          {/* <div style={{
            float: 'left',
            //  marginRight:'70px',
            paddingTop: '25px',
            fontSize: '1.8vh', fontWeight: 'bold',
          }}>
            PROMIS-POS Integration Token  <br />
            <span style={{ fontSize: '11px', color: '#5C9CE8' }}>
              [Note: PROMIS-POS Token use to integrate 'Table Reservation', 'E-Bill', and 'Loyalty']
            </span>

          </div>
          <div style={{
            textAlign: 'right',
            // float:'right',
            paddingTop: '33px',
          }}>
            <Icon
              style={{ cursor: 'pointer', ...promisStyle, fontSize: '17px' }}

              onClick={() => {
                setTwoCopyStyle({ color: '' });
                setCaptainStyle({ color: '' });
                setPromisStyle({ color: 'green' })
                copy(tokenPromis && tokenPromis.token)
              }} name='copy outline' textAlign='right'>
            </Icon>
          </div>
          <Form size='mini'>
            <Dropdown className="propertydp"
              search
              selection
              options={propertyOptions}
              onChange={promisposHandler}
              width="100px"
              placeholder="Choose Outlet"
            />
            <Input
              style={{ marginLeft: '3px', width: '340px' }}
              value={tokenPromis && tokenPromis.token}
            />
          </Form> */}
          {/*  */}

        </Modal.Content>

      </Modal>
      {/* token popup ends  */}

    </Container>
  )
}

export default ViewOrg;